export default "__VITE_PUBLIC_ASSET__c2dbe596__"